module.exports = __webpack_public_path__ + "img/H3.19af2853.png";